<template>
    <div class="tw-flex tw-mb-1">
        <p class="tw-text-gray-400 tw-font-semibold tw-mr-1">
            {{ label }}:
        </p>
        <p class="normal-text secondary-c">
            {{ value }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'ProfileStatistic',
    props: ['label', 'value'],
}
</script>
